import React from "react";
import { Spinner } from "@heroui/react";

interface SelectNoOptionsMessageProps {
  isLoading: boolean;
  t: (key: string) => string;
}

const SelectNoOptionsMessage: React.FC<SelectNoOptionsMessageProps> = React.memo(({ isLoading, t }) => (
  isLoading ? (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spinner />
      <span style={{ marginLeft: "10px" }}>{t("searching")}</span>
    </div>
  ) : (
    <>{t("no_match_found")}</>
  )
));

export default SelectNoOptionsMessage;